import { useCallback, useContext, useEffect, useState } from "react";
import { TeamContext } from "../context";


const useProposedSolutionCards = (): [any] => {
    const { game } = useContext(TeamContext);
    const [proposedSolutionCardsArray, setProposedSolutionCardsArray] = useState<any>([]);
   
    const fillProposedSolutionCardsArray = useCallback(() => {
        const proposedSolutionCards = game?.gameInfo.proposedSolutionCards;
        if (proposedSolutionCards) {

            let propSolutionCardsArray = [];

            for (const [key, value] of Object.entries(proposedSolutionCards)) {

                const mappedPlayerSolution = {
                    player: {
                        fullName: game?.players.find((player: any) => player.email === key)?.fullName || "",
                        nickname: game?.players.find((player: any) => player.email === key)?.nickname || "",
                        email: key,
                        color: game?.players.find((player: any) => player.email === key)?.color || "",
                        profileIcon: process.env.REACT_APP_BACKEND_URL + "images/" + key + ".png",
                        isReady: true,
                    },
                    //TAGUJEM
                    card: {
                        type: Object(value).type,
                        frontImagePath: "",
                        backImagePath: "",
                        backIcon: "",
                        frontIcon: "",
                        description: Object(value).description,
                        title: Object(value).title,
                        name: "",
                        id: Object(value)._id,
                        content: Object(value).description,
                        link: Object(value).info,
                        info: Object(value).info,
                    }
                }

                propSolutionCardsArray.push(mappedPlayerSolution);

            }

            setProposedSolutionCardsArray(propSolutionCardsArray);
        }
    }, [game?.gameInfo.proposedSolutionCards, game?.players]);

    useEffect(() => {
        fillProposedSolutionCardsArray();
    }, [fillProposedSolutionCardsArray]);

    return [proposedSolutionCardsArray];
}

export default useProposedSolutionCards;